import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { isEqual } from 'lodash';
import { useEffect, useState } from 'react';
import { nonFatalBuildError } from './errorReporting';
import csDataManager, { initiateLivePreview } from './livePreview';

/**
 * Sets up Live editing if the active environemnt is preview.
 *
 * @param pageData - The data it has to update when live preview is active
 *
 * @returns the fetched data if live preview active, else the initial data
 */
const useLivePreviewSetup = <TData>(pageData: TData): TData => {
  const [data, setData] = useState<TData>(pageData);
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';
  const isPreview = activeEnv === 'preview';

  const fetchLivePreviewData = async (): Promise<void> => {
    try {
      if (!csDataManager) {
        return;
      }
      console.info('Fetching Content Entry Change...');
      const updatedData = await csDataManager.get<TData>(pageData);
      if (isEqual(updatedData, data)) {
        return;
      }
      console.info('Changes detected, updating content...');
      setData(updatedData);
    } catch (error) {
      nonFatalBuildError(
        'Something went wrong hile fetching live preview data.',
        'Returning the initial data back...'
      );
      setData(pageData);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!isPreview || !csDataManager) {
        return;
      }
      initiateLivePreview();
      ContentstackLivePreview.onLiveEdit(fetchLivePreviewData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data;
};

export default useLivePreviewSetup;
